import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Globals } from 'app/_globals';
import { ContractorManagerService } from 'app/_services/contractor-manager.service';
import { ContractorService } from 'app/_services/contractor.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contractor-details',
  templateUrl: './contractor-details.component.html'
})
export class ContractorDetailsComponent implements OnInit {

  role: any;
  routeRole: any;
  tabitems: any[] = [];

  selectedContractor: any;
  selectedContractorId: any;

  contractorDetailsForm: FormGroup;

  public contractorManagers: any[] = [];
  selectedManager = { label: 'Select Manager', value: null };

  constructor(
    public contractorService: ContractorService,
    public globals: Globals,
    public activatedRoute: ActivatedRoute,
    public fb: FormBuilder,
    public contractorManagerService: ContractorManagerService
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.selectedContractorId = params.id;
    });

    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    this.tabitems = [
      { path: '/' + this.routeRole + '/contractors/', title: 'All Contractors', class: 'back-link' },
      { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/details', title: 'Details' },
      { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/workers', title: 'Workers' },
      { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/certificates', title: 'Certificates' },
      { path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/contacts', title: 'Contacts' },
    ];

    this.contractorDetailsForm = fb.group({
      name: new FormControl(),
      description: new FormControl(),
      additionalInfo: new FormControl(),
      oem: new FormControl(),
      address: new FormControl(),
      mainContactNo: new FormControl()
    });
  }

  ngOnInit() {
    this.getSelectedContractor(this.selectedContractorId);
    this.getAllContractorManagers();
  }

  public getSelectedContractor(id) {
    this.contractorService.getContractorById(id)
      .subscribe((data: any) => {
        this.selectedContractor = data;
        if (data.maintenanceManager !== null) {
          this.selectedManager = { label: data.maintenanceManager.firstName + ' ' + data.maintenanceManager.lastName, value: data.maintenanceManager }
        }
        if(this.selectedContractor.oem){
          this.tabitems.push({ path: '/' + this.routeRole + '/contractors/' + this.selectedContractorId + '/procedures', title: 'Procedures' })
        }
        this.assignFormValues();
      })
  }

  // Get All Managers
  public getAllContractorManagers() {
    this.contractorManagerService.getAllContractorManagersNoPagination()
      .subscribe((data: any) => {
        this.contractorManagers.push(this.selectedManager);
        data.forEach(element => {
          const obj = {
            label: element.firstName + ' ' + element.lastName,
            value: element
          };
          this.contractorManagers.push(obj);
        })
      })
  }

  public assignFormValues() {
    this.contractorDetailsForm.patchValue({
      name: this.selectedContractor.name,
      description: this.selectedContractor.description,
      additionalInfo: this.selectedContractor.additionalInfo,
      address: this.selectedContractor.address,
      mainContactNo: this.selectedContractor.mainContactNo,
      oem: this.selectedContractor.oem,
    })
  }

  // Save Changes to Company Details
  public onContractorDetailsFormSubmit() {
    const values = this.contractorDetailsForm.value;
    const body = {
      id: this.selectedContractorId,
      name: values.name,
      additionalInfo: values.additionalInfo,
      oem: values.oem,
      description: values.description,
      address: values.address,
      mainContactNo: values.mainContactNo
    }
    this.contractorService.editContractor(body)
      .subscribe((data: any) => {
        Swal.fire(
          'Success',
          'Contractor Updated!',
          'success'
        );
        this.getSelectedContractor(this.selectedContractorId);
      })
  }

  // Set Contractor Manager
  public onSelectedManagerChange(event) {
    const body = {
      maintenanceId: Number(this.selectedContractorId),
      skylarkUserId: event.value.id
    }
    this.contractorService.setContractorManager(body)
      .subscribe((data: any) => {
        this.getSelectedContractor(this.selectedContractorId);
      })
  }

}
